var Backbone, SupportHelpWizardController, SupportIntermediateView, SupportIntermediateViewTemplate,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportHelpWizardController = require('../helpWizardController');

Backbone = require('backbone');

Backbone.$ = $;

SupportIntermediateViewTemplate = require('../../intermediate_view.html.mustache');

SupportIntermediateView = (function(superClass) {
  extend(SupportIntermediateView, superClass);

  function SupportIntermediateView() {
    this.redirectingToOrder = bind(this.redirectingToOrder, this);
    return SupportIntermediateView.__super__.constructor.apply(this, arguments);
  }

  SupportIntermediateView.prototype.className = "intermediate_page";

  SupportIntermediateView.prototype.events = {
    'click #about_an_order': 'redirectingToOrder',
    'click .not_about_an_order_link': 'redirectSelectIssue'
  };

  SupportIntermediateView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    return this.template = SupportIntermediateViewTemplate;
  };

  SupportIntermediateView.prototype.render = function() {
    window.hideFloatingBoldChat();
    return this.$el.html(toHtml(this.template, {}, this.I18nScope));
  };

  SupportIntermediateView.prototype.redirectingToOrder = function() {
    return this.redirectToLogin();
  };

  SupportIntermediateView.prototype.redirectSelectIssue = function() {
    var ref;
    if (window.evaluate((ref = window.experiments) != null ? ref.shouldEnableForceLogin : void 0)) {
      redirectToFaq();
      return false;
    } else {
      return SupportHelpWizardController.abruptStepTwoFlow();
    }
  };

  SupportIntermediateView.prototype.redirectToLogin = function() {
    var refUrl;
    if ((window.isTouchUserAgent != null) && window.isTouchUserAgent && isUS()) {
      refUrl = window.touchSupportUrl;
      return window.location.href = "/login?return_to=" + (encodeURIComponent(refUrl));
    } else {
      refUrl = window.SUPPORTBASEURL;
      return window.location.href = "/login?ref=" + (encodeURIComponent(refUrl));
    }
  };

  return SupportIntermediateView;

})(Backbone.View);

module.exports = SupportIntermediateView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvaW50ZXJtZWRpYXRlX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvaW50ZXJtZWRpYXRlX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUEsK0ZBQUE7RUFBQTs7OztBQUFBLDJCQUFBLEdBQThCLE9BQUEsQ0FBUSx5QkFBUjs7QUFDOUIsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBQ2IsK0JBQUEsR0FBa0MsT0FBQSxDQUFRLHVDQUFSOztBQUU1Qjs7Ozs7Ozs7b0NBQ0osU0FBQSxHQUFVOztvQ0FFVixNQUFBLEdBQ0U7SUFBQSx1QkFBQSxFQUF5QixvQkFBekI7SUFDQSxnQ0FBQSxFQUFpQyxxQkFEakM7OztvQ0FHRixVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixJQUFDLENBQUEsUUFBRCxHQUFZO0VBRkY7O29DQUlaLE1BQUEsR0FBUSxTQUFBO0lBQ04sTUFBTSxDQUFDLG9CQUFQLENBQUE7V0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLElBQUwsQ0FBVSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsRUFBbEIsRUFBc0IsSUFBQyxDQUFBLFNBQXZCLENBQVY7RUFGTTs7b0NBSVIsa0JBQUEsR0FBbUIsU0FBQTtXQUNqQixJQUFDLENBQUEsZUFBRCxDQUFBO0VBRGlCOztvQ0FHbkIsbUJBQUEsR0FBb0IsU0FBQTtBQUNsQixRQUFBO0lBQUEsSUFBRyxNQUFNLENBQUMsUUFBUCx5Q0FBa0MsQ0FBRSwrQkFBcEMsQ0FBSDtNQUNFLGFBQUEsQ0FBQTtBQUNBLGFBQU8sTUFGVDtLQUFBLE1BQUE7YUFJRSwyQkFBMkIsQ0FBQyxpQkFBNUIsQ0FBQSxFQUpGOztFQURrQjs7b0NBT3BCLGVBQUEsR0FBZ0IsU0FBQTtBQUNkLFFBQUE7SUFBQSxJQUFHLGlDQUFBLElBQTRCLE1BQU0sQ0FBQyxnQkFBbkMsSUFBdUQsSUFBQSxDQUFBLENBQTFEO01BQ0UsTUFBQSxHQUFTLE1BQU0sQ0FBQzthQUNoQixNQUFNLENBQUMsUUFBUSxDQUFDLElBQWhCLEdBQXVCLG1CQUFBLEdBQW1CLENBQUMsa0JBQUEsQ0FBbUIsTUFBbkIsQ0FBRCxFQUY1QztLQUFBLE1BQUE7TUFJRSxNQUFBLEdBQVMsTUFBTSxDQUFDO2FBQ2hCLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBaEIsR0FBdUIsYUFBQSxHQUFhLENBQUMsa0JBQUEsQ0FBbUIsTUFBbkIsQ0FBRCxFQUx0Qzs7RUFEYzs7OztHQXpCb0IsUUFBUSxDQUFDOztBQWlDL0MsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
